import { Icon, Tooltip } from '@salecycle/ui-component-library';
import React from 'react';
import styled from 'styled-components';
import { TooltipHtml } from '../common/TooltipHtml';

interface IProps {
  active: boolean;
  icon: string;
  onClick?: (e?: React.MouseEvent) => void;
  tooltipHeading?: string;
  tooltipDescription?: string;
  validationPass?: number;
  validationWarning?: number;
  validationFail?: number;
}

const TabElement = styled.div<IProps>`
  position: relative;
  &&:hover {
    background-color: ${({ theme, active }) => (active ? theme.vars.newColor.blue1 : theme.vars.newColor.lightGS2)};
    border: ${({ theme, active }) =>
      active ? `1px solid ${theme.vars.newColor.blue1}` : `1px solid ${theme.vars.newColor.lightGS1}`};
  }
  &&:active {
    color: ${({ theme }) => theme.vars.newColor.white};
    background-color: ${({ theme }) => theme.vars.newColor.blue1};
    border: ${({ theme }) => `1px solid ${theme.vars.newColor.blue1}`};
    transition: none;
  }
  box-shadow: none;
  font-size: 14px;
  font-weight: normal;
  text-align: center;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
  height: 35px;
  min-width: 30px;
  background-color: ${props => (props.active ? props.theme.vars.newColor.blue1 : 'transparent')};
  border: 1px solid transparent;
  padding: 7px;
  color: ${props => (props.active ? props.theme.vars.newColor.white : props.theme.vars.newColor.darkGS2)};

  svg {
    align-self: center;
    justify-self: center;
  }
  .validationPass {
    right: -6px;
    background: green;
  }
  .validationWarning {
    right: 7px;
    background: orange;
  }
  .validationFail {
    right: 20px;
    background: red;
  }
  .validation {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    bottom: -10px;
    font-size: 10px;
  }
`;

/*
  New Tab Component for icon bar
*/
export const SideBarValidationTabIcon = (props: IProps) => {
  return props.tooltipHeading ? (
    <Tooltip
      title={props.tooltipHeading}
      html={<TooltipHtml heading={props.tooltipHeading} description={props.tooltipDescription} />}
      position="right"
    >
      <TabElement
        {...props}
        className="tabButton"
        onClick={props.onClick}
        id={props.tooltipHeading}
        validationPass={props.validationPass}
      >
        <Icon icon={props.icon} />
        <span className="validation validationPass">{props.validationPass}</span>
        <span className="validation validationWarning">{props.validationWarning}</span>
        <span className="validation validationFail">{props.validationFail}</span>
      </TabElement>
    </Tooltip>
  ) : (
    <TabElement {...props} className="tabButton" onClick={props.onClick} id={props.icon}>
      <Icon icon={props.icon} />
    </TabElement>
  );
};
